import type { TenantRoleListItemLocal } from '../api/types/TenantLocal';

/** Roles base de todo tenant; el list del backend omite `isSystem`, así que se reconocen por roleId. */
export const TENANT_SYSTEM_ROLE_IDS: ReadonlySet<string> = new Set([
    'tenant_admin',
    'retailer_admin',
    'store_manager',
    'collection_agent',
]);

/** Un rol es de sistema si el backend lo marca o si es uno de los roles base. */
export function isTenantSystemRole(role: Pick<TenantRoleListItemLocal, 'roleId' | 'isSystem'>) {
    return role.isSystem || TENANT_SYSTEM_ROLE_IDS.has(role.roleId);
}

/** Roles base de plataforma; se reconocen por roleId por si el list llega sin `isSystem`. */
export const PLATFORM_SYSTEM_ROLE_IDS: ReadonlySet<string> = new Set(['platform_super_admin']);

export function isPlatformSystemRole(role: { roleId: string; isSystem?: boolean }): boolean {
    return role.isSystem === true || PLATFORM_SYSTEM_ROLE_IDS.has(role.roleId);
}
